// extracted by mini-css-extract-plugin
export default {"gridBox":"detail_gridBox__TyVvY"};